export default "__VITE_ASSET__CZPUKwvw__"